<template>
    <modal @modal-close="handleClose">
        <div class="modal-wrapper">
            <CloseButton @click="handleClose" />

            <div class="modal-content">
                <template v-if="!reachedFreePlanLimit">
                    <div class="item" v-if="todo.inspection.checklist_title">
                        <h4>{{ $t("Checklist title") }}</h4>
                        <p>{{ todo.inspection.checklist_title }}</p>
                    </div>

                    <div class="item" v-if="todo.inspection.schedule_title">
                        <h4>{{ $t("Schedule title") }}</h4>
                        <p>{{ todo.inspection.schedule_title }}</p>
                    </div>

                    <div class="item" v-if="todo.inspection.description">
                        <h4>{{ $t("Description") }}</h4>
                        <p class="whitespace-pre-wrap">{{ formattedDescription }}</p>
                    </div>

                    <div class="item">
                        <h4>{{ $t("Due date") }}</h4>
                        <p>{{ $du(todo.due_at, 'shortDateTime') }}</p>
                    </div>

                    <div class="item" v-if="todo.site">
                        <h4>{{ $t("Site") }}</h4>
                        <p>{{ todo.inspection.checklist_sites[todo.site] }}</p>
                    </div>

                    <div class="item">
                        <h4>{{ $t("Last downloaded at") }}</h4>
                        <p>{{ $du(todo.checked_at, 'shortDateTime') }}</p>
                    </div>

                    <div class="item" v-if="todo.users && todo.users.length > 0">
                        <h4>{{ assigneeLegend }}</h4>
                        <p>{{ todo.users.join(", ") }}</p>
                    </div>
                </template>

                <reached-inspection-limit-message v-else />

                <offline-inspection-message v-if="displayOfflineWarning" />
            </div>

            <div class="modal-actions-outer-wrapper">
                <div class="modal-actions-inner-wrapper">

                    <button
                        v-if="reachedFreePlanLimit"
                        type="button"
                        class="modal-actions-primary"
                        @click.prevent="handleClose"
                    >
                        {{ $t('Go back') }}
                    </button>
                    <template v-else-if="todo.draft">
                        <button
                            type="button"
                            class="modal-actions-secondary"
                            @click.prevent="handleRestartInspection"
                        >{{ $t('Delete Draft & Restart Inspection') }}</button>

                        <button
                            type="button"
                            class="modal-actions-primary"
                            @click.prevent="handleResumeDraft"
                        >{{ $t('Resume Draft') }}</button>
                    </template>

                    <template v-else>
                        <button
                            type="button"
                            class="modal-actions-primary"
                            @click.prevent="handleStartInspection"
                        >{{ $t('Start Inspection') }}</button>
                    </template>
                </div>
            </div>
        </div>

  </modal>
</template>

<script>
import { mapGetters } from 'vuex';
import Loader from '@mobile/components/Loader.vue';
import ReachedInspectionLimitMessage from '@mobile/components/ReachedInspectionLimitMessage';
import OfflineInspectionMessage from '@mobile/components/OfflineInspectionMessage';
import CloseButton from '@/components/Modals/CloseButton.vue';
import OnFreePlan from '@mobile/mixins/OnFreePlan';

export default {
    name: 'TodosInspectionModal',

    mixins: [OnFreePlan],

    components: {
        OfflineInspectionMessage,
        ReachedInspectionLimitMessage,
        Loader,
        CloseButton,
    },

    props: {
        todo: {
            type: Object,
            required: true,
        },
    },

    computed: {
        ...mapGetters({
            online: 'connection/online',
        }),

        dueAt() {
            return this.localizeDateTime(this.todo.due_at);
        },

        reachedFreePlanLimit() {
            return this.user.subscription.inspections && this.user.subscription.inspections.limit_reached;
        },

        displayOfflineWarning() {
            return !this.reachedFreePlanLimit && !this.online && this.isOnFreePlan;
        },

        lastCheckedAt() {
            return this.todo.checked_at
                ? this.localizeDateTime(this.todo.checked_at)
                : null;
        },

        isInspection() {
            return this.todo.type === 10;
        },

        formattedDescription() {
            const { description } = this.todo.inspection;
            if (!description) return '-';
            if (description.length > 100) return `${description.substr(0, 100 - 1)}…`;
            return description;
        },

        assigneeLegend() {
            return this.todo.users.length > 1 ? this.$t('Assignees') : this.$t('Assignee');
        },
    },

    methods: {
        handleClose() {
            this.$emit('close');
        },

        handleRestartInspection() {
            this.$emit('restartInspection');
        },

        handleStartInspection() {
            this.$emit('startInspection');
        },

        handleResumeDraft() {
            this.$emit('resumeDraft');
        },

    },


};
</script>
